import { call, put, takeLatest, all } from 'redux-saga/effects';

import { customerId } from 'common/helpers/tokenHelper';
import { addAPIError, removeAPIError } from 'redux/apiErrors/sagas';

import { listReservations, getReservation, cancelReservation } from './api';
import {
  LIST_RESERVATIONS_REQUEST,
  GET_RESERVATION_REQUEST,
  GET_RESERVATION_SUCCESS,
  RESERVATION_LIST_REQUESTING,
  RESERVATION_OBJECT_REQUESTING,
  LIST_RESERVATIONS_SUCCESS,
  RESET_RESERVATION_ISFETCHING,
  CANCEL_RESERVATION_REQUEST
} from './constants';

function* list(action) {
  try {
    yield call(removeAPIError);
    yield put({ type: RESERVATION_LIST_REQUESTING });
    const response = yield call(
      listReservations,
      customerId(),
      action.queryString
    );
    yield put({
      type: LIST_RESERVATIONS_SUCCESS,
      payload: response.data
    });
  } catch (error) {
    yield put({ type: RESET_RESERVATION_ISFETCHING });
    yield call(addAPIError, error);
  }
}

function* get(action) {
  try {
    yield call(removeAPIError);
    yield put({ type: RESERVATION_OBJECT_REQUESTING });
    const response = yield call(getReservation, action.reservationId);
    yield put({
      type: GET_RESERVATION_SUCCESS,
      payload: response.data
    });
  } catch (error) {
    yield put({ type: RESET_RESERVATION_ISFETCHING });
    yield call(addAPIError, error);
  }
}

function* cancel(action) {
  try {
    yield call(removeAPIError);
    yield put({ type: RESERVATION_OBJECT_REQUESTING });
    const response = yield call(
      cancelReservation,
      customerId(),
      action.reservationId
    );
    yield put({
      type: GET_RESERVATION_SUCCESS,
      payload: response.data
    });
    if (action.onSuccess) {
      action.onSuccess(response.data);
    }
  } catch (error) {
    if (action.onError) {
      action.onError();
    }
    yield put({ type: RESET_RESERVATION_ISFETCHING });
    yield call(addAPIError, error);
  }
}

function* watchList() {
  yield takeLatest(LIST_RESERVATIONS_REQUEST, list);
  yield takeLatest(GET_RESERVATION_REQUEST, get);
  yield takeLatest(CANCEL_RESERVATION_REQUEST, cancel);
}

export default function* reservationSagas() {
  yield all([watchList()]);
}
